import { render, staticRenderFns } from "./AppDesktop.vue?vue&type=template&id=3b246a24&lang=pug&"
import script from "./AppDesktop.vue?vue&type=script&lang=js&"
export * from "./AppDesktop.vue?vue&type=script&lang=js&"
import style0 from "./AppDesktop.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports